import { gql } from '@apollo/client';
import React, { useState } from 'react';
import EmptyState from '../components/EmptyState';
import InfiniteScrollWaypoint from '../components/InfiniteScrollWaypoint';
import type { DraftsList_DraftsFragment } from '../graphql/generated/graphqlTypes';
import CreatePostButton from '../post/CreatePostButton';
import type { MetadataAttribute } from '../post/PostRow';
import PostRow from '../post/PostRow';

const DRAFT_FRAGMENT = gql`
  fragment DraftsList_drafts on Post {
    id
    ...PostRow_post
  }

  ${PostRow.fragments.post}
`;

interface DraftsListProps {
  drafts: DraftsList_DraftsFragment[];
  fetchMoreDrafts: (() => void) | null;
  metadataAttribute: MetadataAttribute;
}

const DraftsList = ({
  drafts,
  fetchMoreDrafts,
  metadataAttribute,
}: DraftsListProps) => {
  const [activePreviewId, setActivePreviewId] = useState<string | null>(null);

  return (
    <>
      {drafts.length === 0 ? (
        <EmptyState
          imageName="posts"
          title="Nothing yet."
          message="So, write something!"
          action={
            <CreatePostButton size="large" variant="secondary">
              Start writing
            </CreatePostButton>
          }
        />
      ) : (
        <>
          {drafts.map((post, index) => (
            <PostRow
              key={post.id}
              post={post}
              inList={index > 0}
              activePreviewId={activePreviewId}
              onActivePreviewIdChange={setActivePreviewId}
              metadataAttribute={metadataAttribute}
            />
          ))}
        </>
      )}
      <InfiniteScrollWaypoint fetchMore={fetchMoreDrafts} />
    </>
  );
};

DraftsList.fragments = { drafts: DRAFT_FRAGMENT };

export default DraftsList;
